import {useOverlayStore} from '@app/common/stores'
import Home from '@app/components/Home/Home'
import React from 'react'

export default function AdminAuditLogModalOpener(): React.JSX.Element {
  const setAdminAuditLogOpen = useOverlayStore(state => state.setAdminAuditLogOpen)
  React.useEffect(() => {
    setAdminAuditLogOpen(true)
  }, [setAdminAuditLogOpen])

  return <Home />
}
